import { render, staticRenderFns } from "./Component_ReqInfo.vue?vue&type=template&id=123bdada&scoped=true&"
import script from "./Component_ReqInfo.vue?vue&type=script&lang=js&"
export * from "./Component_ReqInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123bdada",
  null
  
)

export default component.exports